export enum MUTATION_KEYS {
  CREATE_DOCUMENT_THEME = 'CREATE_DOCUMENT_THEME',
  UPDATE_DOCUMENT_THEME = 'UPDATE_DOCUMENT_THEME',
  DELETE_DOCUMENT_THEME = 'DELETE_DOCUMENT_THEME',
}

export default MUTATION_KEYS
